import React, { useContext } from 'react';

import styled from 'styled-components';

import { ListContext } from '@contexts/ListContext';

import { NwTag } from '@components/Gui/NwTag';

const FamiliesSelectorContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin: 0.75rem 1rem 2rem 0.75rem;
`;

const FamiliesSelector = ({ families, selectedFamilies, onSelectFamily, onSelectAll }) => {
    const { GetFamilyName } = useContext(ListContext);

    const isSelected = (family) => selectedFamilies.includes(family);

    return (
        <FamiliesSelectorContainer>
            <NwTag
                pointer
                key="all-families"
                clickaction={onSelectAll}
                type={selectedFamilies.length === 0 ? 'primary' : null}
            >
                all transactions
            </NwTag>
            {families.map((family) => (
                <NwTag
                    pointer
                    key={family}
                    clickaction={() => onSelectFamily(family)}
                    type={isSelected(family) ? 'primary' : null}
                >
                    {GetFamilyName(family)}
                </NwTag>
            ))}
        </FamiliesSelectorContainer>
    );
};

export default FamiliesSelector;
